import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { closeModal } from "../../redux/features/modalSlice";

import {useGetStateQuery,} from "../../redux/services/stateService/state.Services";
import {useUpdateLocationMutation,} from "../../redux/services/locationService/location.Services";

import { useGetCityQuery } from "../../redux/services/cityService/city.Services";

import {
  successToast,
  errorToast,
} from "../../Utils/toast";

function EditLocation({ data }) {
  const dispatch = useDispatch();

  const [updateState, { isLoading: updateLoading }] =
    useUpdateLocationMutation();

  // State List API
  const {
    data: stateResponse,
    isLoading: stateLoading,
  } = useGetStateQuery();

  // City List API
  const {
    data: cityResponse,
    isLoading: cityLoading,
  } = useGetCityQuery();

  const stateData = stateResponse?.data || [];
  const cityData = cityResponse?.data || [];

  const [formData, setFormData] = useState({
    id: data?.id || "",
    name: data?.name || "",
    stateName: data?.stateName || "",
    cityName: data?.cityName || "",
    status: data?.status || "active",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateState = async () => {
    try {
      const payload = {
        id: formData.id,
        name: formData.name,
        stateName: formData.stateName,
        cityName: formData.cityName,
        status: formData.status,
      };

      console.log("Payload =>", payload);

      const response = await updateState(payload).unwrap();

      successToast(
        response?.message || "Updated Successfully"
      );

      dispatch(closeModal());

    } catch (error) {
      console.log(error);

      errorToast(
        error?.data?.message ||
          "Update Failed"
      );
    }
  };

  return (
    <>
      <div className="custom-modal-body">
        <div className="model-custum">

          {/* Name */}
          <div className="edit-form-group">
            <label>Location Name</label>

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Enter Location Name"
            />
          </div>

          {/* State Dropdown */}
          <div className="edit-form-group mt-3">
            <label>Select State</label>

            <select
              name="stateName"
              value={formData.stateName}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">
                {stateLoading
                  ? "Loading States..."
                  : "Select State"}
              </option>

              {stateData.map((state) => (
                <option
                  key={state.id}
                  value={state.name}
                >
                  {state.name}
                </option>
              ))}
            </select>
          </div>

          {/* City Dropdown */}
          <div className="edit-form-group mt-3">
            <label>Select City</label>

            <select
              name="cityName"
              value={formData.cityName}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="">
                {cityLoading
                  ? "Loading Cities..."
                  : "Select City"}
              </option>

              {cityData.map((city) => (
                <option
                  key={city.id}
                  value={city.name}
                >
                  {city.name}
                </option>
              ))}
            </select>
          </div>

          {/* Status */}
          <div className="edit-form-group mt-3">
            <label>Status</label>

            <select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="active">
                Active
              </option>

              <option value="inactive">
                Inactive
              </option>
            </select>
          </div>

        </div>
      </div>

      {/* Buttons */}
      <div className="modal-btn-group">

        <button
          className="cancel-btn"
          onClick={() =>
            dispatch(closeModal())
          }
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleUpdateState}
          disabled={updateLoading}
        >
          {updateLoading
            ? "Updating..."
            : "Save Changes"}
        </button>

      </div>
    </>
  );
}

export default EditLocation;